import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
import { ImageSlider as GeminiImageSlider } from "@gemini/ui";
import { ImageFilledIcon } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { useGalleryContext } from "@/components/Gallery/contexts";
import { useFarbwelt, useIsDesktop } from "@/hooks";
import { ImageFallback } from "./ImageFallback";
export const ImageSlider = ({ images, accessibilityLabel, ratio = "4/3", shouldAlwaysDisplayArrows = false, indicatorOffset = "32", isRounded = false, }) => {
    const wrapperRef = useRef(null);
    const { t } = useI18n();
    const isDesktop = useIsDesktop();
    const { isFarbweltActive } = useFarbwelt();
    const hasNoImages = !images || (images === null || images === void 0 ? void 0 : images.length) === 0;
    const { setCurrentSlideKey, setCurrentStep } = useGalleryContext();
    const handleOnChange = useCallback((slideKey) => {
        setCurrentSlideKey(slideKey);
        setCurrentStep(images.findIndex((image) => image.key === slideKey));
    }, [setCurrentSlideKey, setCurrentStep, images]);
    const borderStyle = isDesktop
        ? Object.assign({ borderColor: "color.border.light.default", borderWidth: "borderWidth.1", borderStyle: "solid" }, (!isFarbweltActive && {
            borderRadius: "radius.16",
        })) : {};
    const renderSliderPreviewFallback = () => (_jsx(ImageFallback, { variant: "preview", title: t("gallery.image.fallback.no_photo_message"), description: t("gallery.image.fallback.contact_message"), icon: ImageFilledIcon }));
    if (hasNoImages) {
        return (_jsx(Box, Object.assign({ width: "100%", overflow: "hidden", unsafe_style: { aspectRatio: ratio } }, borderStyle, { borderRadius: isRounded ? "radius.16" : "radius.none", display: "flex", children: renderSliderPreviewFallback() })));
    }
    return (_jsx(Box, Object.assign({ ref: wrapperRef, width: "100%" }, borderStyle, { children: _jsx(GeminiImageSlider, { images: images, ratio: ratio, accessibilityLabel: accessibilityLabel, isSwipeable: true, indicatorOffset: indicatorOffset, shouldAlwaysDisplayArrows: shouldAlwaysDisplayArrows, isRounded: isRounded, onChange: handleOnChange, touchAction: "auto" }) })));
};
